import React, {lazy, useState, useEffect, useCallback} from 'react';
import Dimensions from './Dimensions';
import * as SizeFunctions from './SizeFunctions';
import NormalBtn from './NormalBtn';
import './TextField.css';
import PopUp from './PopUp';
import QuestionList from './QuestionList';
import DisplayPage from './DisplayPage';
import * as SharedAcross from './Common/SharedAcross';
import * as TreeAcross from './Common/TreeAcross';

import FilterTree from './FilterTree';
import HTMLTree from './HTMLTree';
import FunctionArticulationTree from './FunctionArticulationTree';


const importView = chartName =>
  lazy(() =>
    import(`./${chartName}`)
      .catch(() => import(`./NullChart`))
  );

function App() {


  var host = window.location.host;
  var storage = host.split(".")[0];

  const [sessionIDUserSubdomainIDVPassword, setSessionIDUserSubdomainIDVPassword] = useState(localStorage.getItem('spec'+storage+'Everything') || "0 -1 ");

  React.useEffect(() => {
    localStorage.setItem('spec'+storage+'Everything', sessionIDUserSubdomainIDVPassword);
  }, [sessionIDUserSubdomainIDVPassword, storage]);

  function getHostAndParams(){
    var host = window.location.host;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    var phone = urlParams.get('phone');
    var name = urlParams.get('name');
    var key = urlParams.get('key');
    var shortcut = urlParams.get('shortcut');
    return {host, phone, name, key, shortcut};
  }

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingWhat, setIsSubmittingWhat] = useState("");
  const [extraScreenSet, setExtraScreenSetRaw] = useState([]);

  const [sessionHistoryID, setSessionHistoryID] = useState(0);

  const [subdomainID, setSubdomainID] = useState(0);
  const [isGlobalAdmin, setIsGlobalAdmin] = useState(0);
  const [isAdminMode, setIsAdminMode] = useState(0);
  const [haveAccess, setHaveAccess] = useState(0);

  const [AdminMode, setAdminMode] = useState(null);

  const [left, setLeft] = useState(false);
  const [display, setDisplay] = useState(false);

  
  const { height, width } = Dimensions();


  var sessionSet = SharedAcross.getSessionIDEtc(sessionIDUserSubdomainIDVPassword);
  var sessionID = sessionSet.sessionID;
  var userSubdomainID = sessionSet.userSubdomainID;
  var vPassword = sessionSet.vPassword;

  const [mobilePage, setMobilePage] = useState("");
  const [desktopPage, setDesktopPage] = useState("");

  const [leftHandTarget, setLeftHandTarget] = useState(-1);
  const [rightHandTarget, setRightHandTarget] = useState(-1);

  const [pictures, setPictures] = useState([]);
  const [picturePreview, setPicturePreview] = useState([]);


  //did mount
  useEffect(()=>{
    startSpec(userSubdomainID, vPassword, sessionID, true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function domainSpecificUpdates(subdomainSpecificResponse){
      var pageResponse = subdomainSpecificResponse[0].v;
      var subdomainID = pageResponse[0].v;
      setSubdomainID(subdomainID);
      var haveAccess = pageResponse[1].v;
      setHaveAccess(haveAccess);
      var documentTitle = pageResponse[2].v;
      document.title = documentTitle;

      var mobilePage = pageResponse[3];
      var desktopPage = pageResponse[4];
      setMobilePage(mobilePage);
      setDesktopPage(desktopPage);


      setIntentStuff(subdomainSpecificResponse[1]);
      // setPastCompiled(indvResponse[4].v);
  }

  function doStartPage(host){

    return function(response){

      var indvResponse = response.v[0].v;
      var userSubdomainID = indvResponse[1].v;
      var newString = indvResponse[0].v + " " + userSubdomainID + " " + indvResponse[2].v;
      if (newString !== sessionIDUserSubdomainIDVPassword){
        setSessionIDUserSubdomainIDVPassword(newString);
      }

      var subdomainSpecificResponse = response.v[1].v;
      domainSpecificUpdates(subdomainSpecificResponse);

      popAll();

      if (userSubdomainID === 3){
        setIsGlobalAdmin(true);
      }else{
        setIsGlobalAdmin(false);
      }
    }

  }


// https://yck.cues.sg/?phone=91010271&name=he ruimin&key=hahahah

  function startSpec(userSubdomainID, vPassword, sessionID, isInitial){
    var hostParams = getHostAndParams();
    var host = hostParams.host;
    var phone = "";
    var name = "";
    var key = "";
    var shortcut = "";

    if (isInitial){
      phone = hostParams.phone;
      name = hostParams.name;
      key = hostParams.key;
      if (isInitial){
        shortcut = hostParams.shortcut;
      }
    }

    adminActionFull("startSpec", {sessionID, host, phone, name, key, shortcut}, doStartPage(host), userSubdomainID, vPassword, []);
  }

  function setExtraScreenSet(extraScreenSetIn){
    var extraScreenSet = extraScreenSetIn.map((aScreen, index)=>{
      return aScreen;
    })
    setExtraScreenSetRaw(extraScreenSet);
  }



  const clickBack = useCallback(
    function(e){ 
       // 
      if (extraScreenSet.length > 0 || isAdminMode > 0 || intentTree.length > 1){
        actualClickBack();
      }
    },[extraScreenSet, isAdminMode, left]);

  const escFunction = useCallback((event) => {

    if (event.keyCode === 27){ //esc
      clickBack();
      event.preventDefault();
    }

  }, [clickBack]);


  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);


  function handlerPopState(e){
      e.preventDefault();
      actualClickBack();          
  };


  function actualClickBack(){
    if (extraScreenSet.length > 0){
      extraScreenSet.pop();
      setExtraScreenSet(extraScreenSet);
      return;
    }else if (isAdminMode > 0){
      setIsAdminMode(0);
      return;
    }else if (left){
      if (intentTree.length > 1){
        getPosition(intentTree.length - 2, []);
        return;
      }
    }

    window.history.go(-1);
  };

  function getPosition(pos, levelsIn){
    var levels = SharedAcross.convertLevels(levelsIn);
    adminAction("submitLocation", {action:"getPosition", sessionHistoryID, pos, levels}, setIntentStuff);
    // adminAction("getPosition", {sessionHistoryID, pos}, postGetPosition);

  }

  SizeFunctions.useEventListener('popstate', handlerPopState);


  function doOnceOffActions(onceOffActions){
    onceOffActions.map((aOnceOf, index)=>{
      if (aOnceOf.t === "tuple"){
        var action = aOnceOf.v[0].v;
        if (action === "alert"){
          var msg = aOnceOf.v[1].v;
          alert(msg);
        }else{
          console.log(action);
        }
      }
      return null;
    })
  }
  function setIntentStuff(intentStuff){
    popAll();

    var newSessionHistoryID = intentStuff.v[0].v;
    setSessionHistoryID(+newSessionHistoryID);
    setLeft(intentStuff.v[1]);

    var displayPiece = intentStuff.v[2];
    if (displayPiece.t === "tuple"){
      var onceOffActions = displayPiece.v[0].v;
      if (onceOffActions === "error"){
        window.alert(displayPiece.v[1].v);
      }else{
        doOnceOffActions(onceOffActions);
        var persistentActions = displayPiece.v[1];
        setDisplay(persistentActions);
      }
    }else{
      setDisplay(false);
    }
    var additionalOnceOff = intentStuff.v[3].v;
    doOnceOffActions(additionalOnceOff);

  }

  function popAll(){
    setExtraScreenSet([]);
  }

  function adminAction(requestType, formulaUriToAdd, postPostFunction, files){
      adminActionFull(requestType, formulaUriToAdd, postPostFunction, userSubdomainID, vPassword, files);
  }

  function clickLogOut(e){
    setSessionIDUserSubdomainIDVPassword("0 -1 ");
    updateUserInfo(-1, "");
  }


  function postMigration(userSubdomainID, vPassword){
    return function(response){
      var sessionID = response.v[0].v;
      var newString = sessionID + " " + userSubdomainID + " " + vPassword;
      if (newString !== sessionIDUserSubdomainIDVPassword){
        setSessionIDUserSubdomainIDVPassword(newString);
      }

      var subdomainSpecificResponse = response.v[1].v;
      domainSpecificUpdates(subdomainSpecificResponse);
      if (sessionID === 15910){
        setIsGlobalAdmin(true);
      }else{
        setIsGlobalAdmin(false);
      }
    }
  }

  function updateUserInfo(userSubdomainIDIn, vPassword){

    var userSubdomainID = +userSubdomainIDIn;
    if (userSubdomainID === -1){
      startSpec(userSubdomainID, vPassword, 0, false);
    }else{
      popAll();
      adminActionFull("migrateSession", {sessionHistoryID}, postMigration(userSubdomainID, vPassword), userSubdomainID, vPassword, []);
    }
  }

  function adminActionFull(requestType, formulaUriToAdd, postPostFunction, userSubdomainIDIn, vPasswordIn, files){
    SharedAcross.adminActionFullFn(setIsSubmittingWhat, setIsSubmitting, sessionID, subdomainID, clickLogOut)(requestType, formulaUriToAdd, postPostFunction, userSubdomainIDIn, vPasswordIn, files);
  }

  function clickAdminMode(isAdmin){
    return function(e){
      if (isAdmin === 0){
        clickBack();
      }else{
        if (isAdmin === 1){
          if (!AdminMode){
            const Chart = importView("AdminMode");
            setAdminMode(Chart);
          }
          pushState("admin");
        }
        setIsAdminMode(isAdmin);      

      }
    }
  }

  function addToExtraScreen(extraScreen){
    pushState("extraScreen");
    extraScreenSet.push(extraScreen);
    setExtraScreenSet(extraScreenSet);
  }

  function clickLogIn(e){
    addToExtraScreen({v:"logIn", post:updateUserInfo, subdomainID:subdomainID, userSubdomainID:userSubdomainID});
  }

  if (isAdminMode === 1){
    return <React.Suspense fallback="Loading..."><AdminMode adminAction={adminAction} clickAdminMode={clickAdminMode} /></React.Suspense>  
//    
  }

  function pushState(state){
    window.history.pushState({state},"", '');
  }


  function topLevelSubmitLocation(selectedIntentText, selectedIntentID, selectedPostPart){
    return function(e){
      setIsSubmittingWhat(selectedIntentText);
      adminAction("submitLocation", {action:"clickButton", levels:[], sessionHistoryID, selectedIntentText, selectedIntentID, selectedPostPart}, setIntentStuff, []);
    }
  }

  var popUps = extraScreenSet.map((aScreen, index)=>{
    return (<PopUp extraScreen={aScreen} width={width} height={height} clickBack={clickBack} setExtraScreenSet={setExtraScreenSet} />);
  });

  var intentTree = [];

  function selectPositionWithSubActionFn(pos){
    return function(subaction, treePositionIn, value, variableNos){
      var treePosition = treePositionIn.join("_");
      var levels = [];
      adminAction("submitLocation", {action:"clickTreePosition", subaction, value, variableNos, levels:SharedAcross.convertLevels(levels), pos, treePosition, sessionHistoryID}, setIntentStuff);      
    }

  }

  function proofFnFn(pos){
    return function(value, subaction){
      var levels = [];
      adminAction("submitLocation", {action:"proofFns", subaction, value, levels:SharedAcross.convertLevels(levels), pos, sessionHistoryID}, setIntentStuff);      
    }

  }


  function nullFunction(e){};

  var firstLineTitle = "";
  var titleOverride = "";
//
  var userPiece;
  if (host === ""){
  }else if (haveAccess === 1){

    if (left){
      intentTree = left.v[1].v;
      var relevantWidth = width - 20;
      var topRow = [];
      if (isGlobalAdmin){
        topRow.push({f:clickAdminMode(1), i:"/client_pictures/home_grey_128.png", t:"Admin"})
      }


        var lPieces = [];
        var startPoint = 0;

        intentTree.map((intentTreeA, index)=>{
            var questionSet = intentTreeA.v[0];
            var extraPiece = questionSet.v[4];
            if (extraPiece.t === "tuple"){
              var val = extraPiece.v[0].v;
            
              if (val === "questionList"){
                lPieces.push({z:"baseline", startPoint, endPoint:+index - 1,widthWeight:1});
                lPieces.push({z:"questionList", extraPiece, rightPieceNos:+index, text:"View Project", widthWeight:1});

                startPoint = +index;
              }else if (val === "dispTree"){
                lPieces.push({z:"baselineTree", startPoint, endPoint:intentTree.length - 1,widthWeight:1});
                var tree = extraPiece.v[2];
                var isFunctionMode = extraPiece.v[4];
                if (isFunctionMode.t === "tuple"){
                  lPieces.push({z:"functionMode", tree:isFunctionMode.v[3], pos:+index,widthWeight:1});
                }else{
                  var position = extraPiece.v[1].v;
                  var qPiece = extraPiece.v[3];

                  var relevantTree = tree;
                  var isNegative = false;

                  for (var i4 = 0; i4 < position.length; i4++){
                    var thisPos = position[i4].v;
                    if (thisPos > -1){
                      relevantTree = relevantTree.v[2].v[thisPos];
                    }else{
                      isNegative = true;
                      break;
                    }
                  }

                  if (!isNegative){
                      firstLineTitle = relevantTree.v[1].v;
                      var titles = relevantTree.v[4].v;
                      if (titles.length > 0){
                        titleOverride = titles[0].v;
                      }
                  }
                  var levels = [];
                  var leftRightPieces = getTrees(tree, position, isFunctionMode, +index, qPiece, adminAction, levels, sessionHistoryID, setIntentStuff);
                  lPieces = lPieces.concat(leftRightPieces);
                }
                startPoint = +intentTree.length;
              }else if (val === "proof"){
                lPieces.push({z:"baselineTree", startPoint, endPoint:intentTree.length - 1,widthWeight:1});
                lPieces.push({z:"proof", extraPiece, pos:+index, text:"Proof", widthWeight:2});
                startPoint = +intentTree.length;
              }
            }
            return null;
        })

        if (startPoint < intentTree.length){
          lPieces.push({z:"baseline", startPoint, endPoint:intentTree.length - 1, widthWeight:1});
        }

      var showAllExtra = true;

      if (lPieces.length === 1){
        var cover = mobilePage;
        if (relevantWidth > 700){
          cover = desktopPage;
          relevantWidth = width * 0.7;
        }

        userPiece = <QuestionList isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} left={left} cover={cover} display={display} adminAction={adminAction} setIntentStuff={setIntentStuff} width={relevantWidth} sessionHistoryID={sessionHistoryID} updateUserInfo={updateUserInfo} height={height} topRow={topRow} subdomainID={subdomainID} isSubmitting={isSubmitting} showAllExtra={showAllExtra} levels={[]}  firstLineTitle={""} setHandTarget={setRightHandTarget} handTarget={leftHandTarget} isRight={false} addToExtraScreen={addToExtraScreen} userSubdomainID={userSubdomainID} clickLogIn={clickLogIn} clickLogOut={clickLogOut} boldTarget={""}  picturePreview={picturePreview} setPicturePreview={setPicturePreview} setPictures={setPictures} pictures={pictures} startPoint={0} endPoint={intentTree.length - 1} titleOverride={titleOverride} setExtraScreenSet={setExtraScreenSet} />

      }else{
        if (width > 700){
          showAllExtra = false;
        }

        function doLeftRights(left1, isLast, relevantWidth){
          var style = {verticalAlign:"top"};
          var piece = null;

          if (left1.z === "questionList"){

            var boldTarget = "";
            var questionAnswers = left.v[1].v;
            for (var i3 = 0; i3 < questionAnswers.length; i3++){
              var anAnswer = questionAnswers[i3].v[1].v;
              if (anAnswer[0].v === 130){
                boldTarget = anAnswer[2].v;
              }
            }

            piece = <DisplayPage  isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} extraPiece={left1.extraPiece} display={display} height={height} width={relevantWidth} adminAction={adminAction} updateUserInfo={updateUserInfo} subdomainID={subdomainID} setIntentStuff={setIntentStuff} sessionHistoryID={sessionHistoryID} pos={left1.rightPieceNos} levels={[]}  isSubmitting={isSubmitting} setHandTarget={setLeftHandTarget} handTarget={rightHandTarget} boldTarget={boldTarget} addToExtraScreen={addToExtraScreen} setExtraScreenSet={setExtraScreenSet}/>
          }else if (left1.z === "baseline" || left1.z === "baselineTree"){
            style.backgroundColor = SharedAcross.backgroundColor();
            piece = <QuestionList isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} left={left} cover={mobilePage} display={display} adminAction={adminAction} setIntentStuff={setIntentStuff} width={relevantWidth} sessionHistoryID={sessionHistoryID} updateUserInfo={updateUserInfo} height={height} topRow={topRow} subdomainID={subdomainID} isSubmitting={isSubmitting} showAllExtra={showAllExtra} levels={[]}  firstLineTitle={""} setHandTarget={setRightHandTarget} handTarget={leftHandTarget} isRight={false} addToExtraScreen={addToExtraScreen} userSubdomainID={userSubdomainID} clickLogIn={clickLogIn} clickLogOut={clickLogOut} boldTarget={""}  picturePreview={picturePreview} setPicturePreview={setPicturePreview} setPictures={setPictures} pictures={pictures} startPoint={left1.startPoint} endPoint={left1.endPoint} setExtraScreenSet={setExtraScreenSet}/>
          }else if  (left1.z === "functionMode"){


            piece = <FunctionArticulationTree tree={left1.tree} selectPositionWithSubAction={selectPositionWithSubActionFn(left1.pos)}/>

          }else if (left1.z === "tree"){

            var interactionType = left1.interactionType;
            var position = left1.position;
            var tree = left1.tree;
            var subtitle = left1.subtitle;
            var startLevelsArray = left1.startLevelsArray;
            var isFunctionMode = left1.isFunctionMode;
            var pos = left1.pos;
            var qPiece = left1.qPiece;
            var levels = [];
            var treeIn = left1.treeIn;
            var selectPosition = left1.selectPosition;

            var ansSetInset = null;
            if (isLast){
              var widthHere = relevantWidth;
              if (interactionType === 0){
                var posLengthHere = (position.length - startLevelsArray.length);
                widthHere = relevantWidth - 45 * posLengthHere - 100;
              }
              ansSetInset =  <QuestionList  isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} left={qPiece} cover={false} display={display} adminAction={adminAction} setIntentStuff={setIntentStuff} width={widthHere} sessionHistoryID={sessionHistoryID} updateUserInfo={updateUserInfo} topRow={[]} subdomainID={subdomainID} isSubmitting={isSubmitting}  showAllExtra={true} levels={levels.concat([pos])} firstLineTitle={firstLineTitle} isRight={true} handTarget={-1} setHandTarget={nullFunction} userSubdomainID={-1} clickLogIn={nullFunction} clickLogOut={nullFunction} boldTarget={-1} picturePreview={picturePreview} setPicturePreview={setPicturePreview} setPictures={setPictures} pictures={pictures} startPoint={0} endPoint={qPiece.v[1].v.length - 1} titleOverride={titleOverride} setExtraScreenSet={setExtraScreenSet}/>

            }

            if (interactionType === 2){
              piece = <HTMLTree tree={tree} position={position} selectPosition={selectPosition} startLevelsArray={startLevelsArray} width={relevantWidth} interactionType={interactionType} selectPositionWithSubAction={selectPositionWithSubActionFn(pos)} />
            }else{
              var coverPiece = null;
              if (tree.v[0].v === 33){

                var prior = startLevelsArray.filter((aPiece, index)=>{
                  return +index < startLevelsArray.length - 2;
                });
                var parentalTree = getTreeAtPosition(treeIn, prior);
                var secondLastPosition = startLevelsArray[startLevelsArray.length - 2];
                var thisChild = parentalTree.v[2].v[secondLastPosition];
                if (thisChild){
                  if (thisChild.v[3].v === 0){ //these means that the piece can be shifted around or removed, as it is not head.
                    function parentNodeManipulations(subaction){
                      return function(e){
                        var submit = selectPositionWithSubActionFn(pos);
                        var treePositionIn = startLevelsArray.filter((aPiece, index)=>{
                          return +index < startLevelsArray.length -1;
                        });
                        submit(subaction, treePositionIn, 0,0);
                      }
                    }

                    var objectName = thisChild.v[1].v;

                    var pieces = [{n:"Remove " + objectName,t:"removeBranch"}];
                    if (secondLastPosition > 0){
                      pieces.push({n:"Shift "+ objectName +" Up",t:"shiftUp"});
                    }
                    if (secondLastPosition < parentalTree.v[2].v.length -1){
                      pieces.push({n:"Shift "+ objectName +" Down",t:"shiftDown"});
                    }

                    var convertPieces = SharedAcross.convertToGrid(pieces, 4, true);
                    var tableRows = convertPieces.map((aRow, index)=>{
                      var cells = aRow.map((aCell, index4)=>{
                        if (aCell){
                          var cellStyle= {border:"1px solid #CCC", textAlign:"center", padding:"10px", wordWrap:"break-word", wordBreak:"break-word", whiteSpace: "normal"};
                          return <td key={index4} width="25%" className="selectionChoiceWhite" style={cellStyle} onClick={parentNodeManipulations(aCell.t)}>{aCell.n}</td>
    //
                        }else{
                          return <td key={index4} width="25%"></td>
                        }
    //
                      });
                      return <tr key={index}>{cells}</tr>
                    });
    //
                    coverPiece = <table width="100%"><tbody>{tableRows}</tbody></table>

                  }

                }                  
              }

//
             piece = <div>{coverPiece}<FilterTree tree={tree} position={position} selectPosition={selectPosition} ansSetInset={ansSetInset} startLevelsArray={startLevelsArray} subtitle={subtitle} isFunctionMode={isFunctionMode} isSubmitting={isSubmitting}/></div>
            }

          }
//
          return {piece, style}
        }

        var left1 = lPieces[lPieces.length - 2];
        var right1 = lPieces[lPieces.length - 1];

        var totalWeight = left1.widthWeight + right1.widthWeight;
        var leftWidth = left1.widthWeight * width / totalWeight - 20;
        var rightWidth = right1.widthWeight * width / totalWeight - 20;
        var leftWidthPerc = (100 * left1.widthWeight / totalWeight) + "%";
        var rightWidthPerc = (100 * right1.widthWeight / totalWeight) + "%";

        var leftSet = doLeftRights(left1, 0, leftWidth);
        var rightSet = doLeftRights(right1, 1, rightWidth);

        if (width > 700){

          var verticalPiece = null;
          var heightGap = 0;
          if (lPieces.length > 2){
            var textPiecesS = [];

            if (lPieces.length > 3){
              var nextPosition2 = lPieces[2].positionJustBefore;
              var onClick2 = function(e){
                setIsSubmittingWhat("Home");
                aPiece.selectPosition(nextPosition2);
              }
              if (isSubmittingWhat === "Home"){
                textPiecesS.push({text:"Loading..."});
              }else{
                textPiecesS.push({onClick:onClick2, text:"Home"});
              }
            }
            
            var aPiece = lPieces[lPieces.length - 2];            
            if (aPiece.z === "tree"){
              var nextPosition = lPieces[+lPieces.length - 1].positionJustBefore;
              var onClick = function(e){
                setIsSubmittingWhat("Back");
                aPiece.selectPosition(nextPosition);
              }
              if (isSubmittingWhat === "Back"){
                textPiecesS.push({text:"Loading..."});
              }else{
                textPiecesS.push({onClick, text:"Back"});
              }
            }



            lPieces.filter((aPiece, index)=>{
              return +index < lPieces.length - 2;
            }).map((aPiece, index)=>{
              if (aPiece.z === "baselineTree"){
                left.v[2].v.filter((anOption, index4)=>{
                  var textHere = anOption.v[1].v;
                  return (textHere === "Undo" || textHere === "Redo" || textHere === "Compile Program");
                }).map((anOption, index4)=>{
                  var textHere = anOption.v[1].v;
                  var onClickHere = topLevelSubmitLocation(textHere, anOption.v[0].v, anOption.v[2].v);
                  if (isSubmittingWhat === textHere){
                    textPiecesS.push({text:"Loading..."})
                  }else{
                    textPiecesS.push({onClick:onClickHere, text:textHere})
                  }
                  return null;
                });
              }

              return null;
            });
//
            var textPieces = textPiecesS.map((aText, index)=>{
              return <span key={index} className={"navigationTopBar"} onClick={aText.onClick}>{aText.text}</span>;
            });

//
            heightGap = 50;
//

            verticalPiece = <tr style={{backgroundColor:"#FFEDD9"}}><td colSpan="2"><div style={{width:"100%",padding:"5px"}}>{textPieces}</div></td></tr>

            // verticalPiece = <td width="30px" style={{overflow:"hidden",maxWidth:"20px"}}><div className="containerRotate">{textPieces}</div></td>

          }


          userPiece = <table width={width} height={height} style={{borderCollapse:"collapse", borderSpacing:"0px"}}><tbody>
            {verticalPiece}
            <tr>
            <td width={leftWidthPerc} style={leftSet.style} key="1"><div style={{height:height-heightGap, overflowY:"auto"}}>{leftSet.piece}</div></td>
            <td width={rightWidthPerc} style={rightSet.style} key="2" ><div style={{height:height-heightGap, overflowY:"auto"}}>{rightSet.piece}</div></td></tr>
            </tbody></table>
//
        }else{
          userPiece = <div width="100%">{leftSet.piece}{rightSet.piece}</div>
//
        }
      }
    }    
  }else if (userSubdomainID === -1){
    userPiece = <NormalBtn onClick={clickLogIn} title="Log In"/>
  }else{
    userPiece = <center><br/>{haveAccess}<br/><NormalBtn onClick={clickLogOut} title="Log Out"/></center>
  } 

//
//

  return (
    <div style={SharedAcross.mainOverviewFn(height, width)} >
      {popUps}
      {userPiece}
    </div>
  );
}
//

function getTreeAtPosition(treeIn, position){
  if (position.length === 0){
    return treeIn;
  }else{
    var first = position[0];
    var childTree = treeIn.v[2].v[first];
    var rest = position.filter((aPiece, index)=>{
      return +index > 0;
    });
    return getTreeAtPosition(childTree, rest);

  }
}

function getTrees(treeIn, position, isFunctionMode, pos, qPiece, adminAction, levels, sessionHistoryID, setIntentStuff){

  var leftRightPieces = [];

  function produceTrees(tree, startLevelsArray, interactionType, subtitle, positionJustBefore){

    if (position.length === startLevelsArray.length && interactionType === 2){ //0 and 1 we do things on the top level.
      var p1 = startLevelsArray.join(" ");
      var p2 = position.map((aP, index)=>{
        return aP.v;
      }).join(" ");
      if (p1 === p2){
        return;
      }
    }

    function selectPosition(treePositionIn){
      var treePosition = treePositionIn.join("_");
      adminAction("submitLocation", {action:"clickTreePosition", levels:SharedAcross.convertLevels(levels), pos, treePosition, sessionHistoryID}, setIntentStuff);      
    }

    leftRightPieces.push({z:"tree", tree, treeIn, startLevelsArray, interactionType, subtitle, position, isFunctionMode, pos, qPiece, selectPosition, positionJustBefore,widthWeight:1});
  }

  var currentState = TreeAcross.getInteractionType(treeIn);
  if (currentState !== 2){currentState = 0};
  produceTrees(treeIn, [], currentState, "", "", []);
  if (isFunctionMode.v !== 0){
    return leftRightPieces;
  }


  var childTree = treeIn;

  function getPositionBefore(i){
     return position.filter((aPiece, index)=>{
        return index < i;
      }).map((aPiece, index)=>{
        return aPiece.v;
      })
  }

  for (var i = 0; i < position.length; i++){
    var thisPosition = position[i].v;
    if (thisPosition < 0){
      break;
    }else{
      var guidePieces = childTree.v[4].v;
      var subtitle = "";
      if (guidePieces.length > thisPosition){
        subtitle = guidePieces[thisPosition].v;
      }else if (guidePieces.length > 0){
        subtitle = guidePieces[0].v;
      }

      childTree = childTree.v[2].v[thisPosition];

      var collation = [];

      for (var j = 0; j < i + 1; j++){
        collation.push(+position[j].v);
      }

      if (currentState === 0){
        currentState = TreeAcross.getInteractionType(childTree);
        if (currentState !== 0){
          produceTrees(childTree, collation, currentState, subtitle, getPositionBefore(i));
        }
      }else{
          var newState = TreeAcross.getInteractionType(childTree);
          if (newState !== currentState){
            currentState = newState;
            produceTrees(childTree, collation, currentState, subtitle, getPositionBefore(i));
          }
      // }
      }
    }
  }  
  return leftRightPieces;
}

export default App;

